import { forwardRef } from 'react';
import { DialogButton } from '~/components/ui/Dialog';
import { BoltToken } from '~/components/ui/icons/BoltToken';
import { classNames } from '~/utils/classNames';

interface Props {
  onBack: () => void;
  allowSkip?: boolean;
  className?: string;
}

const SurveyStep0 = forwardRef<HTMLDivElement, Props>(({ onBack, allowSkip, className }, ref) => {
  return (
    <div className={classNames('py-6', className)} ref={ref}>
      <span className="i-heroicons:light-bulb size-16 mb-10 shrink-0" />

      <h2 className="text-[32px]/[39px] font-semibold">Tell us a little about yourself</h2>

      <p className="text-bolt-elements-textSecondary mt-4 px-6 max-w-[480px]">
        Your answers will help us tailor Bolt to your needs and give you the best experience.
      </p>

      <p className="bg-bolt-ds-brandContainer rounded-md px-4 py-2 mt-11 flex items-center">
        <BoltToken className="mr-2" />
        <span className="text-sm text-bolt-ds-brand">
          <span>You’ll be rewarded</span> <b>1M tokens</b> <span>upon completion</span>
        </span>
      </p>

      <div className="mt-8 flex items-center gap-3">
        {allowSkip && (
          <DialogButton type="button" onClick={onBack} variant="secondary">
            Not now
          </DialogButton>
        )}

        <DialogButton type="submit" variant="primary">
          Let’s do it!
        </DialogButton>
      </div>
    </div>
  );
});

SurveyStep0.displayName = 'SurveyStep0';

export default SurveyStep0;
